import { render, staticRenderFns } from "./UserWalletInfo.vue?vue&type=template&id=42a5744d&"
import script from "./UserWalletInfo.vue?vue&type=script&lang=js&"
export * from "./UserWalletInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports